import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./error-boundary.module.css";
import brokenApp from "illustrations/broken-app.png";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Only set state if it's not a webpack compilation error
    if (!error.message?.includes("webpack")) {
      this.setState({
        error: error,
        errorInfo: errorInfo,
      });
    }
  }

  render() {
    // Only show our error UI if it's not a webpack compilation error
    if (
      this.state.hasError &&
      !this.state.error?.message?.includes("webpack")
    ) {
      return <ErrorScreen />;
    }

    return this.props.children;
  }
}

const ErrorScreen = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <img src={brokenApp} alt="Broken App" className={styles.illustration} />
        <div className={styles.explanation}>
          <h1 className="title-1">{t("broken-app.title")}</h1>
          <p className="subtitle-1-variant">{t("broken-app.message")}</p>
        </div>
        <button
          className="btn btn--primary"
          onClick={() => (window.location.href = "/login")}
        >
          {t("broken-app.cta")}
        </button>
      </div>
    </div>
  );
};

export default ErrorBoundary;
